import SalonRepository from './SalonRepository';

export default SalonRepository;
